import { ref, set, get } from "../../firebase-config";

const checkAllowedEmail = async (database, email) => {
  const allowedEmailsRef = ref(database, "allowedEmails");
  const allowedEmailsSnapshot = await get(allowedEmailsRef);
  const allowedEmails = allowedEmailsSnapshot.val();

  if (!allowedEmails) {
    return null;
  }

  return Object.entries(allowedEmails).find(
    ([, value]) => value.email === email
  );
};

const saveUserDataToDatabase = async (database, userData) => {
  const userRef = ref(database, "users/" + userData.uid);
  await set(userRef, userData);
};

const handleSignInError = (showToastMessage, error) => {
  const errorMessage =
    error.code === "auth/popup-closed-by-user"
      ? "Sign in cancelled. Please try again."
      : "Failed to sign in. Please try again later or contact our support team.";
  showToastMessage("Sign-in Failed", errorMessage, "danger");
  console.error("Error signing in:", error);
};

export { checkAllowedEmail, saveUserDataToDatabase, handleSignInError };
